import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.slice.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { convertFromString, convertToString, handle, toFloat, formatPhoneNumber, DATE_CONSIDERATIONS, PlatformType } from "@dp/common";
import DPServices from "@dp/services";
import Base from "./Base";
import { RestaurantDetailModel } from "./models/RestaurantDetailModel";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import MenuItemDetail from "./models/MenuItemDetail";
import moment from "moment-timezone";
import { fetchDistanceFromRestuarant, fetchDistances } from "../utils/common";
import Errors, { ERROR_STRINGS } from "./Errors";
import i18next from "i18next";
var DEFAULT_LATITUDE = 28.4182867;
var DEFAULT_LONGITUDE = -81.4272471;
var Restaurant = (_dec = observable.ref, (_class = /*#__PURE__*/function (_Base) {
  _inherits(Restaurant, _Base);

  var _super = _createSuper(Restaurant);

  function Restaurant(root) {
    var _this$root, _this$root$joinWaitli;

    var _this;

    _classCallCheck(this, Restaurant);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "root", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "locationData", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_restaurantSearchResults", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "detail", _descriptor3, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "categoryIdMenuMap", {});

    _defineProperty(_assertThisInitialized(_this), "menuItemDetailMap", {});

    _defineProperty(_assertThisInitialized(_this), "restaurantIdCategoriesMap", {});

    _defineProperty(_assertThisInitialized(_this), "restaurantDetailModel", null);

    _defineProperty(_assertThisInitialized(_this), "joinWaitlistModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "loading", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_recentRestaurants", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_favoriteRestaurants", _descriptor6, _assertThisInitialized(_this));

    _this.root = root;
    _this.restaurantDetailModel = new RestaurantDetailModel();
    _this.joinWaitlistModel = (_this$root = _this.root) === null || _this$root === void 0 ? void 0 : (_this$root$joinWaitli = _this$root.joinWaitlist) === null || _this$root$joinWaitli === void 0 ? void 0 : _this$root$joinWaitli.joinWaitlistModel;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Restaurant, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this;

      reaction(function () {
        var _this2$root, _this2$root$user;

        return {
          data: (_this2$root = _this2.root) === null || _this2$root === void 0 ? void 0 : (_this2$root$user = _this2$root.user) === null || _this2$root$user === void 0 ? void 0 : _this2$root$user.userProfile
        };
      }, function (_ref) {
        var _this2$restaurantDeta;

        var data = _ref.data;
        (_this2$restaurantDeta = _this2.restaurantDetailModel) === null || _this2$restaurantDeta === void 0 ? void 0 : _this2$restaurantDeta.setUserProfile(data);
      });
      reaction(function () {
        var _this2$root2, _this2$root2$common;

        return {
          data: (_this2$root2 = _this2.root) === null || _this2$root2 === void 0 ? void 0 : (_this2$root2$common = _this2$root2.common) === null || _this2$root2$common === void 0 ? void 0 : _this2$root2$common.appAttributes
        };
      }, function (_ref2) {
        var _this2$restaurantDeta2;

        var data = _ref2.data;
        (_this2$restaurantDeta2 = _this2.restaurantDetailModel) === null || _this2$restaurantDeta2 === void 0 ? void 0 : _this2$restaurantDeta2.setAppAttributes(data);
      });
      reaction(function () {
        var _this2$root3, _this2$root3$user;

        return {
          data: (_this2$root3 = _this2.root) === null || _this2$root3 === void 0 ? void 0 : (_this2$root3$user = _this2$root3.user) === null || _this2$root3$user === void 0 ? void 0 : _this2$root3$user.sessionDetails
        };
      }, function (_ref3) {
        var data = _ref3.data;

        _this2.restaurantDetailModel.setSessionDetails(data);
      });
      reaction(function () {
        var _this2$root$user2, _this2$root$user2$use;

        return {
          data: (_this2$root$user2 = _this2.root.user) === null || _this2$root$user2 === void 0 ? void 0 : (_this2$root$user2$use = _this2$root$user2.userProfile) === null || _this2$root$user2$use === void 0 ? void 0 : _this2$root$user2$use.favoriteLocation
        };
      }, function () {
        _this2.getFavLocations();
      });
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$restaurantDetai, _this$root2, _this$root2$user, _this$restaurantDetai2, _this$root3, _this$root3$common;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (_this$restaurantDetai = this.restaurantDetailModel) === null || _this$restaurantDetai === void 0 ? void 0 : _this$restaurantDetai.setUserProfile((_this$root2 = this.root) === null || _this$root2 === void 0 ? void 0 : (_this$root2$user = _this$root2.user) === null || _this$root2$user === void 0 ? void 0 : _this$root2$user.userProfile);
                (_this$restaurantDetai2 = this.restaurantDetailModel) === null || _this$restaurantDetai2 === void 0 ? void 0 : _this$restaurantDetai2.setAppAttributes((_this$root3 = this.root) === null || _this$root3 === void 0 ? void 0 : (_this$root3$common = _this$root3.common) === null || _this$root3$common === void 0 ? void 0 : _this$root3$common.appAttributes);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "determineLocation",
    value: function () {
      var _determineLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;

        var nearestLocationRestCacheData, nearestLocationRest, currentUserLocation;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.root.platformUtil.getFromLocalStorage("NEAREST_REST_INFO2");

              case 2:
                nearestLocationRestCacheData = _context4.sent;
                nearestLocationRest = convertFromString(nearestLocationRestCacheData);

                if (!(nearestLocationRest && nearestLocationRest.locationDetail)) {
                  _context4.next = 11;
                  break;
                }

                if (!nearestLocationRest.locationDetail) {
                  _context4.next = 10;
                  break;
                }

                runInAction(function () {
                  _this3.locationData = nearestLocationRest.locationData; // this.detail = nearestLocationRest.locationDetail;
                });
                return _context4.abrupt("return");

              case 10:
                runInAction(function () {
                  _this3.locationData = nearestLocationRest.locationData;
                });

              case 11:
                if (!this.locationData) {
                  currentUserLocation = this.root.user.currentUserLocation;

                  if (currentUserLocation) {
                    runInAction(function () {
                      _this3.locationData = _this3.root.user.currentUserLocation;
                    });
                  } else {
                    this.setDefaultLocationDetails();
                  }
                }

                _context4.next = 14;
                return this.setCurrentLocation();

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function determineLocation() {
        return _determineLocation.apply(this, arguments);
      }

      return determineLocation;
    }()
  }, {
    key: "determineCookiedLocation",
    value: function () {
      var _determineCookiedLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resturantIdFromSession, prevResturantIdinStore) {
        var cookiedRestaurantLoaded, resturantId, _restaurantDetail, _restaurantDetail2, _storedResturant, restaurantDetail;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                cookiedRestaurantLoaded = false;
                resturantId = resturantIdFromSession;

                if (!resturantId) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 6;
                return this.root.platformUtil.getFromSessionStorage("MY_LOCATION");

              case 6:
                _storedResturant = _context5.sent;
                restaurantDetail = _storedResturant ? JSON.parse(_storedResturant) : null;

                if (!(restaurantDetail && ((_restaurantDetail = restaurantDetail) === null || _restaurantDetail === void 0 ? void 0 : _restaurantDetail.restaurantInfo) === resturantId && prevResturantIdinStore === resturantId)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", true);

              case 10:
                if (!(!restaurantDetail || ((_restaurantDetail2 = restaurantDetail) === null || _restaurantDetail2 === void 0 ? void 0 : _restaurantDetail2.restaurantInfo) !== resturantId)) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 13;
                return DPServices.Restaurant.getRestaurantDetailsById(resturantId);

              case 13:
                restaurantDetail = _context5.sent;

              case 14:
                _context5.next = 16;
                return this.root.platformUtil.saveInSessionStorage("MY_LOCATION", JSON.stringify(restaurantDetail));

              case 16:
                this.setRestaurantDetail(restaurantDetail);
                cookiedRestaurantLoaded = true;

              case 18:
                return _context5.abrupt("return", cookiedRestaurantLoaded);

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", false);

              case 24:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 21]]);
      }));

      function determineCookiedLocation(_x, _x2) {
        return _determineCookiedLocation.apply(this, arguments);
      }

      return determineCookiedLocation;
    }()
  }, {
    key: "setRestaurantDetail",
    value: function setRestaurantDetail(restaurantDetail) {
      this.detail = restaurantDetail;
    }
  }, {
    key: "getMenuByCategoryId",
    value: function () {
      var _getMenuByCategoryId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(categoryId) {
        var cached, restaurantId, menu;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                cached = this.categoryIdMenuMap[categoryId];

                if (!cached) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", cached);

              case 3:
                restaurantId = this.restaurantId;

                if (!restaurantId) {
                  _context6.next = 17;
                  break;
                }

                _context6.next = 7;
                return DPServices.Menu.getMenu(restaurantId, categoryId);

              case 7:
                menu = _context6.sent;

                if (!menu) {
                  _context6.next = 14;
                  break;
                }

                if (!this.categoryIdMenuMap) {
                  this.categoryIdMenuMap = {};
                }

                this.categoryIdMenuMap[categoryId] = menu;
                return _context6.abrupt("return", menu);

              case 14:
                return _context6.abrupt("return", menu);

              case 15:
                _context6.next = 18;
                break;

              case 17:
                return _context6.abrupt("return", null);

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getMenuByCategoryId(_x3) {
        return _getMenuByCategoryId.apply(this, arguments);
      }

      return getMenuByCategoryId;
    }()
  }, {
    key: "getMenuItemDetailById",
    value: function () {
      var _getMenuItemDetailById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(menuItemId) {
        var menuItemDetail, restaurantId, _this$root4, _this$root4$user, _this$root4$user$sess, _this$root4$user$sess2, _this$root4$user$sess3, isDIPO, menuDetail;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.menuItemDetailMap) {
                  _context7.next = 4;
                  break;
                }

                menuItemDetail = this.menuItemDetailMap[menuItemId];

                if (!menuItemDetail) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return", menuItemDetail);

              case 4:
                restaurantId = this.restaurantId;

                if (!restaurantId) {
                  _context7.next = 19;
                  break;
                }

                isDIPO = ((_this$root4 = this.root) === null || _this$root4 === void 0 ? void 0 : (_this$root4$user = _this$root4.user) === null || _this$root4$user === void 0 ? void 0 : (_this$root4$user$sess = _this$root4$user.sessionDetails) === null || _this$root4$user$sess === void 0 ? void 0 : (_this$root4$user$sess2 = _this$root4$user$sess.successResponse) === null || _this$root4$user$sess2 === void 0 ? void 0 : (_this$root4$user$sess3 = _this$root4$user$sess2.sessionContext) === null || _this$root4$user$sess3 === void 0 ? void 0 : _this$root4$user$sess3.orderTypeValue) === 5;
                _context7.next = 9;
                return DPServices.Menu.getMenuItemDetail(restaurantId, menuItemId, isDIPO ? 5 : undefined);

              case 9:
                menuDetail = _context7.sent;

                if (!menuDetail) {
                  _context7.next = 16;
                  break;
                }

                if (!this.menuItemDetailMap) {
                  this.menuItemDetailMap = {};
                }

                this.menuItemDetailMap[menuItemId] = new MenuItemDetail(menuDetail);
                return _context7.abrupt("return", menuDetail);

              case 16:
                return _context7.abrupt("return", menuDetail);

              case 17:
                _context7.next = 20;
                break;

              case 19:
                return _context7.abrupt("return", null);

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getMenuItemDetailById(_x4) {
        return _getMenuItemDetailById.apply(this, arguments);
      }

      return getMenuItemDetailById;
    }()
  }, {
    key: "redirectToReservations",
    value: function redirectToReservations() {
      if (this.root.platformUtil.PLATFORM_TYPE !== PlatformType.APP) {
        this.root.platformUtil.goToURL("/reservations");
      }
    }
  }, {
    key: "setCurrentLocation",
    value: function () {
      var _setCurrentLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this4 = this;

        var _yield$handle, _yield$handle2, error, response, successResponse, set, nearestRest, restaurantDetail;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return handle(DPServices.Restaurant.searchRestaurants(this.locationData.coords.latitude, this.locationData.coords.longitude, 0, 20));

              case 2:
                _yield$handle = _context8.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                error = _yield$handle2[0];
                response = _yield$handle2[1];

                if (error) {
                  _context8.next = 24;
                  break;
                }

                successResponse = response.successResponse;
                set = successResponse.locationSearchResult;

                if (!(set && set.Location.length > 0)) {
                  _context8.next = 19;
                  break;
                }

                nearestRest = set.Location[0];
                _context8.next = 13;
                return DPServices.Restaurant.getRestaurantDetailsById(nearestRest.restaurantId);

              case 13:
                restaurantDetail = _context8.sent;
                _context8.next = 16;
                return this.root.platformUtil.saveInLocalStorage("NEAREST_REST_INFO2", convertToString({
                  locationData: this.locationData,
                  locationDetail: restaurantDetail
                }));

              case 16:
                runInAction(function () {
                  _this4.detail = restaurantDetail;
                });
                _context8.next = 21;
                break;

              case 19:
                _context8.next = 21;
                return this.root.platformUtil.saveInLocalStorage("NEAREST_REST_INFO2", convertToString({
                  locationData: this.locationData
                }));

              case 21:
                this.mergeSearchResults(set);
                _context8.next = 27;
                break;

              case 24:
                this.setDefaultLocationDetails();
                _context8.next = 27;
                return this.setCurrentLocation();

              case 27:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setCurrentLocation() {
        return _setCurrentLocation.apply(this, arguments);
      }

      return setCurrentLocation;
    }()
  }, {
    key: "mergeSearchResults",
    value: function mergeSearchResults(result) {
      var currentResultSet = this._restaurantSearchResults;

      if (currentResultSet && currentResultSet.Location.length > 0) {
        if (result && result.Location.length > 0) {
          var _this$_restaurantSear;

          var existingSet = currentResultSet.Location;
          var newSet = result.Location;
          var nonExistantSet = [];
          newSet.forEach(function (newRest) {
            var found = false;

            for (var i = 0; i < existingSet.length; i++) {
              var existingRest = existingSet[i];

              if (existingRest.restaurantId === newRest.restaurantId) {
                // Existing Entry
                found = true;
                break;
              }
            }

            if (!found) {
              nonExistantSet.push(newRest);
            }
          });

          var newCount = (_this$_restaurantSear = this._restaurantSearchResults.Location).push.apply(_this$_restaurantSear, nonExistantSet);

          this._restaurantSearchResults.resultsCount = newCount;
        }
      } else {
        this._restaurantSearchResults = result;
      }
    }
  }, {
    key: "setDefaultLocationDetails",
    value: function setDefaultLocationDetails() {
      this.locationData = {
        coords: {
          latitude: DEFAULT_LATITUDE,
          longitude: DEFAULT_LONGITUDE,
          altitude: 0,
          accuracy: null,
          altitudeAccuracy: null,
          heading: null,
          speed: null
        },
        timestamp: moment().toDate().getTime()
      };
    }
  }, {
    key: "getRestaurantPhoneNumberByType",
    value: function getRestaurantPhoneNumberByType(phoneNumbers, type) {
      if (phoneNumbers && phoneNumbers.length > 0) {
        var res = phoneNumbers.filter(function (phoneNumber) {
          return phoneNumber.useType === type;
        });
        return res.length > 0 ? res[0] : null;
      } else {
        return null;
      }
    } // TODO(RES): move above method to this method after all cloud changes

  }, {
    key: "getRestaurantPhoneNumberByTypeCloud",
    value: function getRestaurantPhoneNumberByTypeCloud(phoneNumbers, type) {
      if (phoneNumbers && phoneNumbers.length > 0) {
        var res = phoneNumbers.filter(function (phoneNumber) {
          return phoneNumber.type === type;
        });
        return res.length > 0 ? res[0] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "getRestaurantCurrentWeekClosedStatus",
    value: function getRestaurantCurrentWeekClosedStatus(closedDays, timezone) {
      var restaurantClosedStatusArr = [];

      if (timezone) {
        for (var i = 0; i < 7; i++) {
          var _this$restaurantDetai3;

          restaurantClosedStatusArr.push((_this$restaurantDetai3 = this.restaurantDetailModel) === null || _this$restaurantDetai3 === void 0 ? void 0 : _this$restaurantDetai3.isRestaurantClosed(timezone, closedDays, i));
        }
      }

      return restaurantClosedStatusArr;
    }
  }, {
    key: "getRestaurantHours",
    value: function getRestaurantHours(hours, dayOfWeek, dateToCompare) {
      var _this5 = this;

      var hasSpecialHours = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var additionalHideHourTypes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var overrideHourDescriptionForLocationList = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      var dayObj = {};
      hours.forEach(function (restHour) {
        var _restHour$hourCode;

        var hourCode = restHour.hourCode.hourCode;
        var hourTypeName = restHour === null || restHour === void 0 ? void 0 : (_restHour$hourCode = restHour.hourCode) === null || _restHour$hourCode === void 0 ? void 0 : _restHour$hourCode.hourTypeName;

        try {
          overrideHourDescriptionForLocationList === null || overrideHourDescriptionForLocationList === void 0 ? void 0 : overrideHourDescriptionForLocationList.forEach(function (hcr) {
            var _hcr$, _hcr$2, _hcr$2$trim;

            if (((_hcr$ = hcr[0]) === null || _hcr$ === void 0 ? void 0 : _hcr$.trim()) === hourCode && !!((_hcr$2 = hcr[1]) !== null && _hcr$2 !== void 0 && (_hcr$2$trim = _hcr$2.trim()) !== null && _hcr$2$trim !== void 0 && _hcr$2$trim.length)) {
              hourTypeName = hcr[1];
            }
          });
        } catch (e) {}

        if (moment(dateToCompare).isBetween(restHour.startDate.time, restHour.endDate.time) && restHour.startDayOfWeek <= dayOfWeek && dayOfWeek <= restHour.endDayOfWeek) {
          var _this5$root, _this5$root$common, _this5$root$common$ap, _this5$root$common$ap2, _this5$root$common$ap3, _this5$root$common$ap4, _objectSpread2;

          var hideHourTypes = ((_this5$root = _this5.root) === null || _this5$root === void 0 ? void 0 : (_this5$root$common = _this5$root.common) === null || _this5$root$common === void 0 ? void 0 : (_this5$root$common$ap = _this5$root$common.appAttributes) === null || _this5$root$common$ap === void 0 ? void 0 : (_this5$root$common$ap2 = _this5$root$common$ap.configs) === null || _this5$root$common$ap2 === void 0 ? void 0 : (_this5$root$common$ap3 = _this5$root$common$ap2.hideHourTypes) === null || _this5$root$common$ap3 === void 0 ? void 0 : (_this5$root$common$ap4 = _this5$root$common$ap3.split(",")) === null || _this5$root$common$ap4 === void 0 ? void 0 : _this5$root$common$ap4.map(function (item) {
            return item === null || item === void 0 ? void 0 : item.trim();
          })) || [];
          var hideRestHour = (hideHourTypes === null || hideHourTypes === void 0 ? void 0 : hideHourTypes.length) && (hideHourTypes === null || hideHourTypes === void 0 ? void 0 : hideHourTypes.includes(hourCode)) || (additionalHideHourTypes === null || additionalHideHourTypes === void 0 ? void 0 : additionalHideHourTypes.length) && (additionalHideHourTypes === null || additionalHideHourTypes === void 0 ? void 0 : additionalHideHourTypes.includes(hourCode)) || (restHour === null || restHour === void 0 ? void 0 : restHour.hideRestHour);
          dayObj = _objectSpread(_objectSpread({}, dayObj), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, hourCode, {
            type: hourTypeName,
            startTime: moment("01-01-2022 ".concat(restHour === null || restHour === void 0 ? void 0 : restHour.startTime), "DD-MM-YYYY hh:mm:ss").format(DATE_CONSIDERATIONS.TIME_FORMAT),
            endTime: moment("01-01-2022 ".concat(restHour === null || restHour === void 0 ? void 0 : restHour.endTime), "DD-MM-YYYY hh:mm:ss").format(DATE_CONSIDERATIONS.TIME_FORMAT),
            message: restHour === null || restHour === void 0 ? void 0 : restHour.message,
            hideRestHour: hideRestHour
          }), _defineProperty(_objectSpread2, "hasSpecialHours", hasSpecialHours), _objectSpread2));
        }
      });
      return dayObj;
    }
  }, {
    key: "handleFetchRestaurantError",
    value: function handleFetchRestaurantError(err) {
      var _this$root5, _this$root5$platformU;

      if (((_this$root5 = this.root) === null || _this$root5 === void 0 ? void 0 : (_this$root5$platformU = _this$root5.platformUtil) === null || _this$root5$platformU === void 0 ? void 0 : _this$root5$platformU.PLATFORM_TYPE) === "APP") {
        var _DPServices$Cart$pars;

        var errObj = err;
        var faults = (_DPServices$Cart$pars = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults;
        var haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

        if (haveErrorDescription) {
          throw new Error(haveErrorDescription);
        } else {
          throw Errors.FETCH_LOCATION_RESTAURANT_FAILED;
        }
      } else {
        return this.root.platformUtil.redirectToURL("/locations/location-search?invalidRest=true");
      }
    }
  }, {
    key: "getBaseDomainURL",
    value: function getBaseDomainURL() {
      var _this$root6, _this$root6$platformU;

      return (_this$root6 = this.root) === null || _this$root6 === void 0 ? void 0 : (_this$root6$platformU = _this$root6.platformUtil) === null || _this$root6$platformU === void 0 ? void 0 : _this$root6$platformU.getBaseDomainURL();
    }
  }, {
    key: "fetchLocationRestaurant",
    value: function () {
      var _fetchLocationRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(restaurantId, currentLocation, restaurantNumber, source, hideLoader) {
        var _this6 = this;

        var err, restaurantDetails, _this$root7, _this$root7$common, _this$root7$common$ap, _this$root7$common$ap2, _restaurantDetails, _yield$handle3, _yield$handle4, _this$root8, _this$root8$common, _this$root8$common$ap, _this$root8$common$ap2, _this$root9, _this$root9$common, _this$root9$common$ap, _this$root9$common$ap2, _this$root10, _this$root10$platform, _restaurantDetails2, _this$root11, _this$root11$common, _this$root11$common$a, _this$root11$common$a2, _yield$handle5, _yield$handle6, restNum, _this$root12, _this$root12$common, _this$root12$common$a, _this$root12$common$a2, _this$root13, _this$root13$common, _this$root13$common$a, _this$root13$common$a2, _currentLocation$coor, _currentLocation$coor2, _restaurantDetails3, _this$root14, _this$root14$common, _this$root14$common$a, _this$root14$common$a2, _this$root15, _this$root15$common, _this$root15$common$a, _this$root15$common$a2, _this$root16, _this$root16$common, _this$root16$common$a, _this$root16$common$a2, _this$root16$common$a3, _formatedHideHourForL, _formatedHideHourForL2, _formatedHideHourForL3, _restaurantDetails6, _formatedOverrideHour, _formatedOverrideHour2, _formatedOverrideHour3, _restaurantDetails9, _restaurantDetails9$i, _restaurantDetails10, _restaurantDetails11, _restaurantDetails12, _restaurantDetails13, _restaurantDetails16, _restaurantDetails17, _restaurantDetails17$, _restaurantDetails18, _restaurantDetails18$, _waitTimesResponse, _waitTimesResponse$wa, _waitTimesResponse$wa2, _waitTimesResponse2, _waitTimesResponse2$w, _waitTimesResponse2$w2, _restaurantDetails20, _restaurantDetails21, _DPServices$Restauran, _waitTimesResponse3, coordsObj, resultObj, hideHourForLocationTypes, overrideHourDescriptionForLocation, hideHoursTypeLists, formatedHideHourForLocationTypes, formatedOverrideHourDescriptionForLocation, _hideHourForLocationT, _hideHourForLocationT2, _overrideHourDescript, _overrideHourDescript2, additionalHideHourTypes, overrideHourDescriptionForLocationList, _formatedHideHourForL4, _additionalHideHourTy, _formatedOverrideHour4, currentDay, daysOfWeeks, currenDayIdx, wifiEnabled, hours, restHourInfo, specialHours, locationLevelSplHours, siteLevelSplHours, hasSpecialHours, dayOfWeekT, _restaurantDetails14, _restaurantDetails14$, _Object$keys, _Object$keys2, _Object$keys3, todaysDate, dateToCompare, restHours, restSpclHours, siteSpclHours, locationSpclHours, closedDays, restPhoneNumbers, primary, second, third, waitlistInformation, waitTimesResponse, _restaurantDetails19, highQuote, lowQuote, currentRestaurant;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                err = null;
                restaurantDetails = null;

                if (!hideLoader) {
                  runInAction(function () {
                    _this6.loading = true;
                  });
                }

                if (!restaurantNumber) {
                  _context9.next = 17;
                  break;
                }

                _context9.next = 7;
                return handle(DPServices.Restaurant.getRestaurantDetailsByNumber(restaurantNumber));

              case 7:
                _yield$handle3 = _context9.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                err = _yield$handle4[0];
                restaurantDetails = _yield$handle4[1];

                if (this.root.platformUtil.PLATFORM_TYPE === PlatformType.APP && ((_this$root7 = this.root) === null || _this$root7 === void 0 ? void 0 : (_this$root7$common = _this$root7.common) === null || _this$root7$common === void 0 ? void 0 : (_this$root7$common$ap = _this$root7$common.appAttributes) === null || _this$root7$common$ap === void 0 ? void 0 : (_this$root7$common$ap2 = _this$root7$common$ap.configs) === null || _this$root7$common$ap2 === void 0 ? void 0 : _this$root7$common$ap2.enableTargeter) === "true") {
                  this.getTargetersForCurrentRestaurant((_this$root8 = this.root) === null || _this$root8 === void 0 ? void 0 : (_this$root8$common = _this$root8.common) === null || _this$root8$common === void 0 ? void 0 : (_this$root8$common$ap = _this$root8$common.appAttributes) === null || _this$root8$common$ap === void 0 ? void 0 : (_this$root8$common$ap2 = _this$root8$common$ap.configs) === null || _this$root8$common$ap2 === void 0 ? void 0 : _this$root8$common$ap2.targeterPath, restaurantNumber, (_this$root9 = this.root) === null || _this$root9 === void 0 ? void 0 : (_this$root9$common = _this$root9.common) === null || _this$root9$common === void 0 ? void 0 : (_this$root9$common$ap = _this$root9$common.appAttributes) === null || _this$root9$common$ap === void 0 ? void 0 : (_this$root9$common$ap2 = _this$root9$common$ap.concept) === null || _this$root9$common$ap2 === void 0 ? void 0 : _this$root9$common$ap2.conceptCode);
                }

                if (!(this.root.platformUtil.PLATFORM_TYPE === PlatformType.APP && !((_restaurantDetails = restaurantDetails) !== null && _restaurantDetails !== void 0 && _restaurantDetails.enableLocationDetail))) {
                  _context9.next = 15;
                  break;
                }

                (_this$root10 = this.root) === null || _this$root10 === void 0 ? void 0 : (_this$root10$platform = _this$root10.platformUtil) === null || _this$root10$platform === void 0 ? void 0 : _this$root10$platform.goBack();
                return _context9.abrupt("return", null);

              case 15:
                _context9.next = 25;
                break;

              case 17:
                _context9.next = 19;
                return handle(DPServices.Restaurant.getRestaurantDetailsById(restaurantId));

              case 19:
                _yield$handle5 = _context9.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                err = _yield$handle6[0];
                restaurantDetails = _yield$handle6[1];
                restNum = (_restaurantDetails2 = restaurantDetails) === null || _restaurantDetails2 === void 0 ? void 0 : _restaurantDetails2.restaurantNum;

                if (((_this$root11 = this.root) === null || _this$root11 === void 0 ? void 0 : (_this$root11$common = _this$root11.common) === null || _this$root11$common === void 0 ? void 0 : (_this$root11$common$a = _this$root11$common.appAttributes) === null || _this$root11$common$a === void 0 ? void 0 : (_this$root11$common$a2 = _this$root11$common$a.configs) === null || _this$root11$common$a2 === void 0 ? void 0 : _this$root11$common$a2.enableTargeter) === "true") {
                  this.getTargetersForCurrentRestaurant((_this$root12 = this.root) === null || _this$root12 === void 0 ? void 0 : (_this$root12$common = _this$root12.common) === null || _this$root12$common === void 0 ? void 0 : (_this$root12$common$a = _this$root12$common.appAttributes) === null || _this$root12$common$a === void 0 ? void 0 : (_this$root12$common$a2 = _this$root12$common$a.configs) === null || _this$root12$common$a2 === void 0 ? void 0 : _this$root12$common$a2.targeterPath, restNum, (_this$root13 = this.root) === null || _this$root13 === void 0 ? void 0 : (_this$root13$common = _this$root13.common) === null || _this$root13$common === void 0 ? void 0 : (_this$root13$common$a = _this$root13$common.appAttributes) === null || _this$root13$common$a === void 0 ? void 0 : (_this$root13$common$a2 = _this$root13$common$a.concept) === null || _this$root13$common$a2 === void 0 ? void 0 : _this$root13$common$a2.conceptCode);
                }

              case 25:
                if (err) {
                  this.handleFetchRestaurantError(err);
                }

                if (!(source !== "CREATE_ACCOUNT" && source !== "RESERVATION")) {
                  _context9.next = 79;
                  break;
                }

                if (!restaurantDetails) {
                  _context9.next = 79;
                  break;
                }

                coordsObj = {
                  latitude: currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor = currentLocation.coords) === null || _currentLocation$coor === void 0 ? void 0 : _currentLocation$coor.latitude,
                  longitude: currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor2 = currentLocation.coords) === null || _currentLocation$coor2 === void 0 ? void 0 : _currentLocation$coor2.longitude,
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context9.next = 31;
                return fetchDistanceFromRestuarant(coordsObj, restaurantDetails);

              case 31:
                resultObj = _context9.sent;
                restaurantDetails.mapBoxDistance = resultObj[(_restaurantDetails3 = restaurantDetails) === null || _restaurantDetails3 === void 0 ? void 0 : _restaurantDetails3.restaurantInfo];
                hideHourForLocationTypes = ((_this$root14 = this.root) === null || _this$root14 === void 0 ? void 0 : (_this$root14$common = _this$root14.common) === null || _this$root14$common === void 0 ? void 0 : (_this$root14$common$a = _this$root14$common.appAttributes) === null || _this$root14$common$a === void 0 ? void 0 : (_this$root14$common$a2 = _this$root14$common$a.configs) === null || _this$root14$common$a2 === void 0 ? void 0 : _this$root14$common$a2.hideHourForLocationTypes) || "";
                overrideHourDescriptionForLocation = ((_this$root15 = this.root) === null || _this$root15 === void 0 ? void 0 : (_this$root15$common = _this$root15.common) === null || _this$root15$common === void 0 ? void 0 : (_this$root15$common$a = _this$root15$common.appAttributes) === null || _this$root15$common$a === void 0 ? void 0 : (_this$root15$common$a2 = _this$root15$common$a.configs) === null || _this$root15$common$a2 === void 0 ? void 0 : _this$root15$common$a2.overrideHourDescriptionForLocation) || "";
                hideHoursTypeLists = ((_this$root16 = this.root) === null || _this$root16 === void 0 ? void 0 : (_this$root16$common = _this$root16.common) === null || _this$root16$common === void 0 ? void 0 : (_this$root16$common$a = _this$root16$common.appAttributes) === null || _this$root16$common$a === void 0 ? void 0 : (_this$root16$common$a2 = _this$root16$common$a.configs) === null || _this$root16$common$a2 === void 0 ? void 0 : (_this$root16$common$a3 = _this$root16$common$a2.hideHoursTypeLists) === null || _this$root16$common$a3 === void 0 ? void 0 : _this$root16$common$a3.split(",")) || [];

                try {
                  formatedHideHourForLocationTypes = (hideHourForLocationTypes === null || hideHourForLocationTypes === void 0 ? void 0 : (_hideHourForLocationT = hideHourForLocationTypes.split(",")) === null || _hideHourForLocationT === void 0 ? void 0 : (_hideHourForLocationT2 = _hideHourForLocationT.map(function (item) {
                    return item === null || item === void 0 ? void 0 : item.split(":");
                  })) === null || _hideHourForLocationT2 === void 0 ? void 0 : _hideHourForLocationT2.map(function (item) {
                    var _item$, _item$$split, _item$$split$map;

                    return [item[0], ((_item$ = item[1]) === null || _item$ === void 0 ? void 0 : (_item$$split = _item$.split("/")) === null || _item$$split === void 0 ? void 0 : (_item$$split$map = _item$$split.map(function (hc) {
                      return hc === null || hc === void 0 ? void 0 : hc.trim();
                    })) === null || _item$$split$map === void 0 ? void 0 : _item$$split$map.filter(function (hc) {
                      return !!(hc !== null && hc !== void 0 && hc.length);
                    })) || []];
                  })) || [];
                } catch (error) {
                  formatedHideHourForLocationTypes = [];
                }

                try {
                  formatedOverrideHourDescriptionForLocation = (overrideHourDescriptionForLocation === null || overrideHourDescriptionForLocation === void 0 ? void 0 : (_overrideHourDescript = overrideHourDescriptionForLocation.split(",")) === null || _overrideHourDescript === void 0 ? void 0 : (_overrideHourDescript2 = _overrideHourDescript.map(function (item) {
                    return item === null || item === void 0 ? void 0 : item.split(":");
                  })) === null || _overrideHourDescript2 === void 0 ? void 0 : _overrideHourDescript2.map(function (item) {
                    var _item$2, _item$2$split, _item$2$split$map, _item$2$split$map$fil;

                    return [item[0], ((_item$2 = item[1]) === null || _item$2 === void 0 ? void 0 : (_item$2$split = _item$2.split("/")) === null || _item$2$split === void 0 ? void 0 : (_item$2$split$map = _item$2$split.map(function (hc) {
                      return hc === null || hc === void 0 ? void 0 : hc.trim();
                    })) === null || _item$2$split$map === void 0 ? void 0 : (_item$2$split$map$fil = _item$2$split$map.filter(function (hc) {
                      return !!(hc !== null && hc !== void 0 && hc.length);
                    })) === null || _item$2$split$map$fil === void 0 ? void 0 : _item$2$split$map$fil.map(function (hcr) {
                      var _hcr$split;

                      return hcr === null || hcr === void 0 ? void 0 : (_hcr$split = hcr.split("=")) === null || _hcr$split === void 0 ? void 0 : _hcr$split.map(function (hcr) {
                        return hcr === null || hcr === void 0 ? void 0 : hcr.trim();
                      });
                    })) || []];
                  })) || [];
                } catch (error) {
                  formatedOverrideHourDescriptionForLocation = [];
                }

                additionalHideHourTypes = [];
                overrideHourDescriptionForLocationList = [];

                if (!!((_formatedHideHourForL = formatedHideHourForLocationTypes) !== null && _formatedHideHourForL !== void 0 && _formatedHideHourForL.length) && !!((_formatedHideHourForL2 = formatedHideHourForLocationTypes) !== null && _formatedHideHourForL2 !== void 0 && (_formatedHideHourForL3 = _formatedHideHourForL2.filter(function (hideHourItem) {
                  var _hideHourItem$, _restaurantDetails4;

                  return ((_hideHourItem$ = hideHourItem[0]) === null || _hideHourItem$ === void 0 ? void 0 : _hideHourItem$.trim()) === ((_restaurantDetails4 = restaurantDetails) === null || _restaurantDetails4 === void 0 ? void 0 : _restaurantDetails4.restaurantNum);
                })) !== null && _formatedHideHourForL3 !== void 0 && _formatedHideHourForL3.length)) {
                  additionalHideHourTypes = ((_formatedHideHourForL4 = formatedHideHourForLocationTypes) === null || _formatedHideHourForL4 === void 0 ? void 0 : _formatedHideHourForL4.filter(function (hideHourItem) {
                    var _restaurantDetails5;

                    return hideHourItem[0] === ((_restaurantDetails5 = restaurantDetails) === null || _restaurantDetails5 === void 0 ? void 0 : _restaurantDetails5.restaurantNum);
                  })[0][1]) || [];
                }

                if (!((_restaurantDetails6 = restaurantDetails) !== null && _restaurantDetails6 !== void 0 && _restaurantDetails6.onlineTogo)) {
                  (_additionalHideHourTy = additionalHideHourTypes).push.apply(_additionalHideHourTy, _toConsumableArray(hideHoursTypeLists));
                }

                if (!!((_formatedOverrideHour = formatedOverrideHourDescriptionForLocation) !== null && _formatedOverrideHour !== void 0 && _formatedOverrideHour.length) && !!((_formatedOverrideHour2 = formatedOverrideHourDescriptionForLocation) !== null && _formatedOverrideHour2 !== void 0 && (_formatedOverrideHour3 = _formatedOverrideHour2.filter(function (overrideHourDescriptionItem) {
                  var _overrideHourDescript3, _restaurantDetails7;

                  return ((_overrideHourDescript3 = overrideHourDescriptionItem[0]) === null || _overrideHourDescript3 === void 0 ? void 0 : _overrideHourDescript3.trim()) === ((_restaurantDetails7 = restaurantDetails) === null || _restaurantDetails7 === void 0 ? void 0 : _restaurantDetails7.restaurantNum);
                })) !== null && _formatedOverrideHour3 !== void 0 && _formatedOverrideHour3.length)) {
                  overrideHourDescriptionForLocationList = ((_formatedOverrideHour4 = formatedOverrideHourDescriptionForLocation) === null || _formatedOverrideHour4 === void 0 ? void 0 : _formatedOverrideHour4.filter(function (overrideHourDescriptionItem) {
                    var _restaurantDetails8;

                    return overrideHourDescriptionItem[0] === ((_restaurantDetails8 = restaurantDetails) === null || _restaurantDetails8 === void 0 ? void 0 : _restaurantDetails8.restaurantNum);
                  })[0][1]) || [];
                }

                currentDay = restaurantDetails.currentDay;
                daysOfWeeks = restaurantDetails.daysOfWeeks;

                if (daysOfWeeks) {
                  currenDayIdx = daysOfWeeks.reduce(function (res, dayOfWeek, idx) {
                    if (dayOfWeek.toUpperCase() === currentDay.toUpperCase()) {
                      return idx + 1; // array idx + 1
                    } else {
                      return res;
                    }
                  }, -1);
                  restaurantDetails.currentDaySeq = currenDayIdx;
                }

                wifiEnabled = (_restaurantDetails9 = restaurantDetails) === null || _restaurantDetails9 === void 0 ? void 0 : (_restaurantDetails9$i = _restaurantDetails9.indicatorCode) === null || _restaurantDetails9$i === void 0 ? void 0 : _restaurantDetails9$i.find(function (code) {
                  return code.indicatorCode === "WA";
                });

                if (wifiEnabled) {
                  restaurantDetails.enableWifi = true;
                }

                hours = {};
                restHourInfo = (_restaurantDetails10 = restaurantDetails) === null || _restaurantDetails10 === void 0 ? void 0 : _restaurantDetails10.restHourInfo;
                specialHours = (_restaurantDetails11 = restaurantDetails) === null || _restaurantDetails11 === void 0 ? void 0 : _restaurantDetails11.restSplHrsInfo;
                locationLevelSplHours = (_restaurantDetails12 = restaurantDetails) === null || _restaurantDetails12 === void 0 ? void 0 : _restaurantDetails12.locationLevelSplHours;
                siteLevelSplHours = (_restaurantDetails13 = restaurantDetails) === null || _restaurantDetails13 === void 0 ? void 0 : _restaurantDetails13.siteLevelSplHours;
                hasSpecialHours = false;

                if (restHourInfo) {
                  dayOfWeekT = 1;

                  while (dayOfWeekT <= 7) {
                    todaysDate = moment.tz((_restaurantDetails14 = restaurantDetails) === null || _restaurantDetails14 === void 0 ? void 0 : (_restaurantDetails14$ = _restaurantDetails14.address) === null || _restaurantDetails14$ === void 0 ? void 0 : _restaurantDetails14$.timeZone);
                    dateToCompare = null;

                    if (dayOfWeekT >= restaurantDetails.currentDaySeq) {
                      dateToCompare = todaysDate.add(dayOfWeekT - restaurantDetails.currentDaySeq, "days");
                    } else {
                      dateToCompare = todaysDate.add(7 - restaurantDetails.currentDaySeq + dayOfWeekT, "days");
                    }

                    restHours = this.getRestaurantHours(restHourInfo, dayOfWeekT, dateToCompare, false, additionalHideHourTypes, overrideHourDescriptionForLocationList);
                    restSpclHours = this.getRestaurantHours(specialHours, dayOfWeekT, dateToCompare, true, additionalHideHourTypes, overrideHourDescriptionForLocationList);
                    siteSpclHours = this.getRestaurantHours(siteLevelSplHours, dayOfWeekT, dateToCompare, true, additionalHideHourTypes, overrideHourDescriptionForLocationList);
                    locationSpclHours = this.getRestaurantHours(locationLevelSplHours, dayOfWeekT, dateToCompare, true, additionalHideHourTypes, overrideHourDescriptionForLocationList);

                    if (!hasSpecialHours && (!!((_Object$keys = Object.keys(restSpclHours)) !== null && _Object$keys !== void 0 && _Object$keys.length) || !!((_Object$keys2 = Object.keys(siteSpclHours)) !== null && _Object$keys2 !== void 0 && _Object$keys2.length) || !!((_Object$keys3 = Object.keys(locationSpclHours)) !== null && _Object$keys3 !== void 0 && _Object$keys3.length))) {
                      hasSpecialHours = true;
                    }

                    hours = _objectSpread(_objectSpread({}, hours), {}, _defineProperty({}, dayOfWeekT, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, restHours), restSpclHours), siteSpclHours), locationSpclHours)));
                    dayOfWeekT = dayOfWeekT + 1;
                  }

                  restHourInfo.forEach(function (restHour) {
                    var hourCode = restHour.hourCode.hourCode;

                    if (hourCode === "HOM_REST") {
                      var _restaurantDetails15, _restaurantDetails15$, _restHour$startDate, _restHour$endDate;

                      var currentDate = moment().tz((_restaurantDetails15 = restaurantDetails) === null || _restaurantDetails15 === void 0 ? void 0 : (_restaurantDetails15$ = _restaurantDetails15.address) === null || _restaurantDetails15$ === void 0 ? void 0 : _restaurantDetails15$.timeZone).valueOf();

                      if ((restHour === null || restHour === void 0 ? void 0 : (_restHour$startDate = restHour.startDate) === null || _restHour$startDate === void 0 ? void 0 : _restHour$startDate.time) <= currentDate && currentDate <= (restHour === null || restHour === void 0 ? void 0 : (_restHour$endDate = restHour.endDate) === null || _restHour$endDate === void 0 ? void 0 : _restHour$endDate.time)) {
                        var _restHour$message;

                        var homeRestMessage = (_restHour$message = restHour === null || restHour === void 0 ? void 0 : restHour.message) !== null && _restHour$message !== void 0 ? _restHour$message : restHour === null || restHour === void 0 ? void 0 : restHour.messageDefault;
                        restaurantDetails.homeRest = homeRestMessage;
                      }
                    }
                  });
                }

                restaurantDetails.workingHours = hours;
                restaurantDetails.hasSpecialHours = hasSpecialHours;
                closedDays = ((_restaurantDetails16 = restaurantDetails) === null || _restaurantDetails16 === void 0 ? void 0 : _restaurantDetails16.closedDays) || [];
                restaurantDetails.isRestaurantClosed = DPServices.Common.checkIfRestaurantHoliday((_restaurantDetails17 = restaurantDetails) === null || _restaurantDetails17 === void 0 ? void 0 : (_restaurantDetails17$ = _restaurantDetails17.address) === null || _restaurantDetails17$ === void 0 ? void 0 : _restaurantDetails17$.timeZone, closedDays);
                restaurantDetails.currentWeekClosedStatus = this.getRestaurantCurrentWeekClosedStatus(closedDays, (_restaurantDetails18 = restaurantDetails) === null || _restaurantDetails18 === void 0 ? void 0 : (_restaurantDetails18$ = _restaurantDetails18.address) === null || _restaurantDetails18$ === void 0 ? void 0 : _restaurantDetails18$.timeZone);
                restPhoneNumbers = restaurantDetails.restPhoneNumber;
                primary = this.getRestaurantPhoneNumberByType(restPhoneNumbers, "Primary");

                if (primary) {
                  restaurantDetails.phoneNumber = formatPhoneNumber(primary.Phone);
                  restaurantDetails.unFormattedPhoneNumber = primary.Phone;
                } else {
                  second = this.getRestaurantPhoneNumberByType(restPhoneNumbers, "Secondary");

                  if (second) {
                    restaurantDetails.phoneNumber = formatPhoneNumber(second.Phone);
                    restaurantDetails.unFormattedPhoneNumber = primary.Phone;
                  } else {
                    third = this.getRestaurantPhoneNumberByType(restPhoneNumbers, "Third");

                    if (third) {
                      restaurantDetails.phoneNumber = formatPhoneNumber(third.Phone);
                      restaurantDetails.unFormattedPhoneNumber = primary.Phone;
                    }
                  }
                }

                waitlistInformation = DPServices.Common.currentRestaurantWaitlistInformation(restaurantDetails);
                _context9.prev = 64;
                _context9.next = 67;
                return DPServices.Waitlist.getWaitTime({
                  restaurantNum: (_restaurantDetails19 = restaurantDetails) === null || _restaurantDetails19 === void 0 ? void 0 : _restaurantDetails19.restaurantNum
                });

              case 67:
                waitTimesResponse = _context9.sent;
                _context9.next = 72;
                break;

              case 70:
                _context9.prev = 70;
                _context9.t0 = _context9["catch"](64);

              case 72:
                highQuote = (_waitTimesResponse = waitTimesResponse) === null || _waitTimesResponse === void 0 ? void 0 : (_waitTimesResponse$wa = _waitTimesResponse.waitListTimeDetails) === null || _waitTimesResponse$wa === void 0 ? void 0 : (_waitTimesResponse$wa2 = _waitTimesResponse$wa[0]) === null || _waitTimesResponse$wa2 === void 0 ? void 0 : _waitTimesResponse$wa2.highQuote;
                lowQuote = (_waitTimesResponse2 = waitTimesResponse) === null || _waitTimesResponse2 === void 0 ? void 0 : (_waitTimesResponse2$w = _waitTimesResponse2.waitListTimeDetails) === null || _waitTimesResponse2$w === void 0 ? void 0 : (_waitTimesResponse2$w2 = _waitTimesResponse2$w[0]) === null || _waitTimesResponse2$w2 === void 0 ? void 0 : _waitTimesResponse2$w2.highQuote;
                restaurantDetails.WaitListInformation = _objectSpread(_objectSpread({}, waitlistInformation), {}, {
                  highQuote: highQuote,
                  lowQuote: lowQuote // webAhead: restaurantDetails?.webahead || false,

                });
                currentRestaurant = {
                  webAhead: (_restaurantDetails20 = restaurantDetails) === null || _restaurantDetails20 === void 0 ? void 0 : _restaurantDetails20.webahead,
                  waitListInformation: (_restaurantDetails21 = restaurantDetails) === null || _restaurantDetails21 === void 0 ? void 0 : _restaurantDetails21.WaitListInformation
                };
                restaurantDetails.restaurantWaitTimeStatus = DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Restauran = DPServices.Restaurant) === null || _DPServices$Restauran === void 0 ? void 0 : _DPServices$Restauran.restaurantStatus(currentRestaurant, true); // @ts-ignore TODO: check why this is required.

                restaurantDetails.waitListTimeDetails = (_waitTimesResponse3 = waitTimesResponse) === null || _waitTimesResponse3 === void 0 ? void 0 : _waitTimesResponse3.waitListTimeDetails;
                this.restaurantDetailModel.selectedRestaurantInLocation = restaurantDetails;

              case 79:
                runInAction(function () {
                  _this6.loading = false;
                });
                return _context9.abrupt("return", restaurantDetails);

              case 83:
                _context9.prev = 83;
                _context9.t1 = _context9["catch"](0);
                runInAction(function () {
                  _this6.loading = false;
                });
                this.root.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context9.t1.message);
                throw _context9.t1;

              case 88:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 83], [64, 70]]);
      }));

      function fetchLocationRestaurant(_x5, _x6, _x7, _x8, _x9) {
        return _fetchLocationRestaurant.apply(this, arguments);
      }

      return fetchLocationRestaurant;
    }()
  }, {
    key: "fetchTargetter",
    value: function () {
      var _fetchTargetter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(restaurantNumber, isMobile) {
        var _this$root17, _this$root17$common, _this$root17$common$a, _this$root17$common$a2;

        var _this$root18, _this$root18$common, _this$root18$common$a, _this$root18$common$a2, _this$root19, _this$root19$common, _this$root19$common$a, _this$root19$common$a2;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (((_this$root17 = this.root) === null || _this$root17 === void 0 ? void 0 : (_this$root17$common = _this$root17.common) === null || _this$root17$common === void 0 ? void 0 : (_this$root17$common$a = _this$root17$common.appAttributes) === null || _this$root17$common$a === void 0 ? void 0 : (_this$root17$common$a2 = _this$root17$common$a.configs) === null || _this$root17$common$a2 === void 0 ? void 0 : _this$root17$common$a2.enableTargeter) === "true") {
                  this.getTargetersForCurrentRestaurant((_this$root18 = this.root) === null || _this$root18 === void 0 ? void 0 : (_this$root18$common = _this$root18.common) === null || _this$root18$common === void 0 ? void 0 : (_this$root18$common$a = _this$root18$common.appAttributes) === null || _this$root18$common$a === void 0 ? void 0 : (_this$root18$common$a2 = _this$root18$common$a.configs) === null || _this$root18$common$a2 === void 0 ? void 0 : _this$root18$common$a2.targeterPath, restaurantNumber, (_this$root19 = this.root) === null || _this$root19 === void 0 ? void 0 : (_this$root19$common = _this$root19.common) === null || _this$root19$common === void 0 ? void 0 : (_this$root19$common$a = _this$root19$common.appAttributes) === null || _this$root19$common$a === void 0 ? void 0 : (_this$root19$common$a2 = _this$root19$common$a.concept) === null || _this$root19$common$a2 === void 0 ? void 0 : _this$root19$common$a2.conceptCode, !isMobile && "WEB");
                }

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchTargetter(_x10, _x11) {
        return _fetchTargetter.apply(this, arguments);
      }

      return fetchTargetter;
    }()
  }, {
    key: "getRecentLocations",
    value: function () {
      var _getRecentLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this$root20, _this$root20$user, _this$root20$user$use, _this$root20$user$use2;

        var favouriteLocationsIdSet, recentLocationIds, _currentLocation$coor3, _currentLocation$coor4, _currentLocation$coor5, _currentLocation$coor6, _yield$handle7, _yield$handle8, err, recentLocations, currentLocation, coordsObj, resultObj;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                favouriteLocationsIdSet = new Set();
                (_this$root20 = this.root) === null || _this$root20 === void 0 ? void 0 : (_this$root20$user = _this$root20.user) === null || _this$root20$user === void 0 ? void 0 : (_this$root20$user$use = _this$root20$user.userProfile) === null || _this$root20$user$use === void 0 ? void 0 : (_this$root20$user$use2 = _this$root20$user$use.favoriteLocation) === null || _this$root20$user$use2 === void 0 ? void 0 : _this$root20$user$use2.forEach(function (favouriteLocation) {
                  favouriteLocationsIdSet.add(favouriteLocation.restaurantInfo);
                });
                _context11.next = 4;
                return this.root.platformUtil.getFromLocalStorage("MY_LOCATIONS").then(JSON.parse);

              case 4:
                recentLocationIds = _context11.sent;

                if (!(recentLocationIds && Array.isArray(recentLocationIds))) {
                  _context11.next = 26;
                  break;
                }

                _context11.next = 8;
                return handle(DPServices.Restaurant.getRestaurantByIds(recentLocationIds.toString()));

              case 8:
                _yield$handle7 = _context11.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                err = _yield$handle8[0];
                recentLocations = _yield$handle8[1];

                if (!err) {
                  _context11.next = 14;
                  break;
                }

                throw DPServices.Common.checkAndGetErrorDescription(err) || Errors.GET_RECENT_LOCATION;

              case 14:
                recentLocations === null || recentLocations === void 0 ? void 0 : recentLocations.forEach(function (recentLocation) {
                  if (favouriteLocationsIdSet !== null && favouriteLocationsIdSet !== void 0 && favouriteLocationsIdSet.has(recentLocation.restaurantId)) {
                    recentLocation.isFavourite = true;
                  }
                });
                _context11.next = 17;
                return this.root.user.obtainUserGeoCoordinates();

              case 17:
                _context11.next = 19;
                return this.root.user.currentUserLocation;

              case 19:
                currentLocation = _context11.sent;
                coordsObj = {
                  latitude: (_currentLocation$coor3 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor4 = currentLocation.coords) === null || _currentLocation$coor4 === void 0 ? void 0 : _currentLocation$coor4.latitude) !== null && _currentLocation$coor3 !== void 0 ? _currentLocation$coor3 : DEFAULT_LATITUDE,
                  longitude: (_currentLocation$coor5 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor6 = currentLocation.coords) === null || _currentLocation$coor6 === void 0 ? void 0 : _currentLocation$coor6.longitude) !== null && _currentLocation$coor5 !== void 0 ? _currentLocation$coor5 : DEFAULT_LONGITUDE,
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context11.next = 23;
                return fetchDistances(coordsObj, recentLocations);

              case 23:
                resultObj = _context11.sent;
                recentLocations.forEach(function (location) {
                  var calculateddistance = resultObj[location === null || location === void 0 ? void 0 : location.restaurantId];
                  location.mapBoxDistance = calculateddistance;
                  return location;
                });
                this.recentRestaurants = recentLocations;

              case 26:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getRecentLocations() {
        return _getRecentLocations.apply(this, arguments);
      }

      return getRecentLocations;
    }()
  }, {
    key: "getFavLocations",
    value: function () {
      var _getFavLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this$root$user, _this$root$user$userP;

        var userFavoriteLocations, favoriteLocationIds, _currentLocation$coor7, _currentLocation$coor8, _currentLocation$coor9, _currentLocation$coor10, _yield$handle9, _yield$handle10, err, favoriteLocations, currentLocation, coordsObj, resultObj;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                userFavoriteLocations = (_this$root$user = this.root.user) === null || _this$root$user === void 0 ? void 0 : (_this$root$user$userP = _this$root$user.userProfile) === null || _this$root$user$userP === void 0 ? void 0 : _this$root$user$userP.favoriteLocation;
                favoriteLocationIds = userFavoriteLocations === null || userFavoriteLocations === void 0 ? void 0 : userFavoriteLocations.map(function (item) {
                  return item.restaurantInfo;
                });

                if (!(favoriteLocationIds && Array.isArray(favoriteLocationIds))) {
                  _context12.next = 24;
                  break;
                }

                _context12.next = 5;
                return handle(DPServices.Restaurant.getRestaurantByIds(favoriteLocationIds.toString()));

              case 5:
                _yield$handle9 = _context12.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 2);
                err = _yield$handle10[0];
                favoriteLocations = _yield$handle10[1];

                if (!err) {
                  _context12.next = 11;
                  break;
                }

                throw DPServices.Common.checkAndGetErrorDescription(err) || Errors.GET_FAVORITED_LOCATION;

              case 11:
                favoriteLocations.forEach(function (favouriteLocation) {
                  favouriteLocation.isFavourite = true;
                });
                _context12.next = 14;
                return this.root.user.obtainUserGeoCoordinates();

              case 14:
                _context12.next = 16;
                return this.root.user.currentUserLocation;

              case 16:
                currentLocation = _context12.sent;
                coordsObj = {
                  latitude: (_currentLocation$coor7 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor8 = currentLocation.coords) === null || _currentLocation$coor8 === void 0 ? void 0 : _currentLocation$coor8.latitude) !== null && _currentLocation$coor7 !== void 0 ? _currentLocation$coor7 : DEFAULT_LATITUDE,
                  longitude: (_currentLocation$coor9 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor10 = currentLocation.coords) === null || _currentLocation$coor10 === void 0 ? void 0 : _currentLocation$coor10.longitude) !== null && _currentLocation$coor9 !== void 0 ? _currentLocation$coor9 : DEFAULT_LONGITUDE,
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context12.next = 20;
                return fetchDistances(coordsObj, favoriteLocations);

              case 20:
                resultObj = _context12.sent;
                favoriteLocations.forEach(function (location) {
                  var calculateddistance = resultObj[location === null || location === void 0 ? void 0 : location.restaurantId];
                  location.mapBoxDistance = calculateddistance;
                  return location;
                });
                favoriteLocations.sort(function (a, b) {
                  return a.restaurantName > b.restaurantName ? 1 : -1;
                });
                this.favoriteRestaurants = favoriteLocations;

              case 24:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getFavLocations() {
        return _getFavLocations.apply(this, arguments);
      }

      return getFavLocations;
    }()
  }, {
    key: "getUserLocations",
    value: function () {
      var _getUserLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _yield$handle11, _yield$handle12, err;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return handle(Promise.all([this.getRecentLocations(), this.getFavLocations()]));

              case 2:
                _yield$handle11 = _context13.sent;
                _yield$handle12 = _slicedToArray(_yield$handle11, 1);
                err = _yield$handle12[0];

                if (err && this.root.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.root.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, err.message);
                }

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getUserLocations() {
        return _getUserLocations.apply(this, arguments);
      }

      return getUserLocations;
    }()
  }, {
    key: "getTargetersForCurrentRestaurant",
    value: function () {
      var _getTargetersForCurrentRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(targeterPath, restNumber, conceptCode, channel) {
        var _DPServices$Restauran2, data;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return (_DPServices$Restauran2 = DPServices.Restaurant) === null || _DPServices$Restauran2 === void 0 ? void 0 : _DPServices$Restauran2.getTargetersForCurrentRestaurant(targeterPath, restNumber, conceptCode, channel);

              case 3:
                data = _context14.sent;
                this.restaurantDetailModel.setTargeters(data);
                _context14.next = 10;
                break;

              case 7:
                _context14.prev = 7;
                _context14.t0 = _context14["catch"](0);
                this.restaurantDetailModel.setTargeters({});

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 7]]);
      }));

      function getTargetersForCurrentRestaurant(_x12, _x13, _x14, _x15) {
        return _getTargetersForCurrentRestaurant.apply(this, arguments);
      }

      return getTargetersForCurrentRestaurant;
    }()
  }, {
    key: "showCancelWaitlistSuccessMessage",
    value: function showCancelWaitlistSuccessMessage() {
      var _this$root21, _this$root21$appMessa;

      (_this$root21 = this.root) === null || _this$root21 === void 0 ? void 0 : (_this$root21$appMessa = _this$root21.appMessages) === null || _this$root21$appMessa === void 0 ? void 0 : _this$root21$appMessa.showError(i18next.t("text.rd.from_leave_waitlist_flow_header", {
        defaultValue: "Waitlist cancellation"
      }), i18next.t("text.rd.from_leave_waitlist_flow_body", {
        defaultValue: "You have been successfully removed from the waitlist."
      }), null);
    }
  }, {
    key: "favoriteRestaurants",
    get: function get() {
      return this._favoriteRestaurants;
    },
    set: function set(data) {
      var _this7 = this;

      runInAction(function () {
        _this7._favoriteRestaurants = data;
      });
    }
  }, {
    key: "recentRestaurants",
    get: function get() {
      return this._recentRestaurants;
    },
    set: function set(data) {
      var _this8 = this;

      runInAction(function () {
        _this8._recentRestaurants = data;
      });
    }
  }, {
    key: "restaurantSearchResults",
    get: function get() {
      var results = this._restaurantSearchResults && this._restaurantSearchResults.resultsCount > 0 ? this._restaurantSearchResults.Location : [];
      return results.slice().sort(function (restA, restB) {
        var milesA = toFloat(restA.miles, 0);
        var milesB = toFloat(restB.miles, 0);
        return milesA - milesB;
      });
    }
  }, {
    key: "isLocationWaitListOn",
    get: function get() {
      var _this$root$user2, _this$root$user2$sess, _this$root$user2$sess2, _this$root$user2$sess3;

      return (_this$root$user2 = this.root.user) === null || _this$root$user2 === void 0 ? void 0 : (_this$root$user2$sess = _this$root$user2.sessionDetails) === null || _this$root$user2$sess === void 0 ? void 0 : (_this$root$user2$sess2 = _this$root$user2$sess.successResponse) === null || _this$root$user2$sess2 === void 0 ? void 0 : (_this$root$user2$sess3 = _this$root$user2$sess2.restaurantDetails) === null || _this$root$user2$sess3 === void 0 ? void 0 : _this$root$user2$sess3.isLocationWaitListOn;
    }
  }, {
    key: "restaurantId",
    get: function get() {
      if (this.detail) {
        return this.detail.restaurantInfo;
      } else {
        return null;
      }
    }
  }, {
    key: "currentRestaurant",
    get: function get() {
      return this.detail;
    }
  }]);

  return Restaurant;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locationData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_restaurantSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "detail", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_recentRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_favoriteRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "favoriteRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "favoriteRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantSearchResults", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantSearchResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationWaitListOn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationWaitListOn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRestaurantDetail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRestaurantDetail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentRestaurant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentRestaurant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mergeSearchResults", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mergeSearchResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDefaultLocationDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDefaultLocationDetails"), _class.prototype)), _class));
export { Restaurant as default };